module.exports = __webpack_public_path__ + "static/media/Logo_spstudio2.a5fb8699.png";